import { createAsyncAction } from 'typesafe-actions';
import type { CampaignsFetchResponse } from 'types/Campaign';

export const fetchCampaigns = createAsyncAction(
  'FETCH_CAMPAIGNS_REQUEST',
  'FETCH_CAMPAIGNS_SUCCESS',
  'FETCH_CAMPAIGNS_FAILURE'
)<void, CampaignsFetchResponse, Error>();
